import React from 'react'
import { useNavigate } from 'react-router-dom'
import { Button } from 'antd'

const NotFound = () => {
  const navigate = useNavigate()

  return (
    <main className="vh-100 d-flex flex-column align-items-center justify-content-center gap-4">
      <img width="100px" src="/images/failed-document.svg" alt="404" />
      <h1 className="fs-4 m-0">Página no encontrada</h1>
      <div className="d-flex flex-column align-items-center gap-4">
        <Button
          type="ghost"
          icon={<i className="fas fa-home mr-2" />}
          onClick={() => navigate('/', { replace: true })}
        >
          Volver a la Página Principal
        </Button>

        {/* <span>
          o visita <a href="https://accordttechnology.com" target='_blank' rel="noopener noreferrer">
            ACCORD Technology
          </a>
        </span>*/}
      </div>
    </main>
  )
}

export default NotFound